/* Self-contained shell for the public token-gated partner pages
   (reveal, accept-invite, password reset). Dark teal theme. */
import s from "./portalPublic.module.css";

export function Shell({ children }) {
  return <div className={s.shell}>{children}</div>;
}

export function Card({ title, children }) {
  return (
    <div className={s.card}>
      <div className={s.eyebrow}>Partner portal</div>
      <div className={s.cardTitle}>{title}</div>
      {children}
    </div>
  );
}

export function Btn({ children, onClick, disabled, type = "button", full = true }) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${s.btn} ${full ? "" : s.btnAuto}`}
    >
      {children}
    </button>
  );
}

export function Input(props) {
  const { className = "", ...rest } = props;
  return <input {...rest} className={`${s.input} ${className}`} />;
}

export function Note({ children, tone }) {
  const toneClass =
    tone === "error" ? s.noteError : tone === "warn" ? s.noteWarn : "";
  return <div className={`${s.note} ${toneClass}`}>{children}</div>;
}
